<template>
  <a-card :bordered="false">

    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">

          <a-col :md="6" :sm="12">
            <a-form-item :label="$t('账号')">
              <!--<a-input placeholder="请输入账号查询" v-model="queryParam.username"></a-input>-->
              <j-input :placeholder="$t('输入账号模糊查询')" v-model="queryParam.username"></j-input>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="8">
            <a-form-item :label="$t('性别')">
              <a-select v-model="queryParam.sex" :placeholder="$t('请选择性别')">
                <a-select-option value="">{{ $t('请选择') }}</a-select-option>
                <a-select-option value="1">{{ $t('男性') }}</a-select-option>
                <a-select-option value="2">{{ $t('女性') }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>


          <template v-if="toggleSearchStatus">
            <a-col :md="6" :sm="8">
              <a-form-item :label="$t('账号姓名')">
                <a-input :placeholder="$t('请输入账号姓名')" v-model="queryParam.realname"></a-input>
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="8">
              <a-form-item :label="$t('手机号码')">
                <a-input :placeholder="$t('请输入手机号码查询')" v-model="queryParam.phone"></a-input>
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="8">
              <a-form-item :label="$t('账号状态')">
                <a-select v-model="queryParam.status" :placeholder="$t('请选择')">
                  <a-select-option value="">{{ $t('请选择') }}</a-select-option>
                  <a-select-option value="1">{{ $t('正常') }}</a-select-option>
                  <a-select-option value="2">{{ $t('冻结') }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </template>

          <a-col :md="6" :sm="8">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? $t('收起') : $t('展开') }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>

        </a-row>
      </a-form>
    </div>

    <!-- 操作按钮区域 -->
    <div class="table-operator" style="border-top: 5px">
      <a-button @click="handleAdd" type="primary" icon="plus">{{ $t('添加账号') }}</a-button>
      <a-button type="primary" icon="download" @click="handleExportXls($t('账号信息'))">{{ $t('导出') }}</a-button>
      <!--
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload>
      -->
      <a-button type="primary" icon="hdd" @click="recycleBinVisible=true">{{ $t('回收站') }}</a-button>
      <!-- <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay" @click="handleMenuClick">
          <a-menu-item key="1">
            <a-icon type="delete" @click="batchDel"/>
            删除
          </a-menu-item>
          <a-menu-item key="2">
            <a-icon type="lock" @click="batchFrozen('2')"/>
            冻结
          </a-menu-item>
          <a-menu-item key="3">
            <a-icon type="unlock" @click="batchFrozen('1')"/>
            解冻
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down"/>
        </a-button>
      </a-dropdown> -->
      <j-super-query :fieldList="superQueryFieldList" @handleSuperQuery="handleSuperQuery"/>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;" v-if="selectedRowKeys.length > 0">
        <i class="anticon anticon-info-circle ant-alert-icon"></i>{{ $t('已选择 {count} 项', { count: selectedRowKeys.length }) }}&nbsp;&nbsp;
        <a style="margin-left: 24px" @click="onClearSelected">{{ $t('清空') }}</a>
      </div>

      <a-table
        ref="table"
        bordered
        size="middle"
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        @change="handleTableChange">

        <template slot="avatarslot" slot-scope="text, record, index">
          <div class="anty-img-wrap">
            <a-avatar shape="square" :src="getAvatarView(record.avatar)" icon="user"/>
          </div>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">{{ $t('编辑') }}</a>

          <a-divider type="vertical"/>
          <a @click="handleAreaAuth(record)">{{ $t('区域授权') }}</a>

          <a-divider type="vertical"/>
          <a-dropdown>
            <a class="ant-dropdown-link">
              {{ $t('更多') }} <a-icon type="down"/>
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a href="javascript:;" @click="handleDetail(record)">{{ $t('详情') }}</a>
              </a-menu-item>

              <a-menu-item>
                <a href="javascript:;" @click="handleChangePassword(record.username)">{{ $t('修改密码') }}</a>
              </a-menu-item>

              <a-menu-item>
                <a-popconfirm :title="$t('确定删除吗?')" @confirm="() => handleDelete(record.id)">
                  <a>{{ $t('删除') }}</a>
                </a-popconfirm>
              </a-menu-item>

              <a-menu-item v-if="record.status==1">
                <a-popconfirm :title="$t('确定冻结吗?')" @confirm="() => handleFrozen(record.id,2,record.username)">
                  <a>{{ $t('冻结') }}</a>
                </a-popconfirm>
              </a-menu-item>

              <a-menu-item v-if="record.status==2">
                <a-popconfirm :title="$t('确定解冻吗?')" @confirm="() => handleFrozen(record.id,1,record.username)">
                  <a>{{ $t('解冻') }}</a>
                </a-popconfirm>
              </a-menu-item>
              <!--
              <a-menu-item>
                <a href="javascript:;" @click="handleAgentSettings(record.username)">代理人</a>
              </a-menu-item>
              -->
            </a-menu>
          </a-dropdown>
        </span>


      </a-table>
    </div>
    <!-- table区域-end -->

    <user-modal ref="modalForm" @ok="modalFormOk"></user-modal>

    <user-area-auth-modal ref="userAreaModalForm" @ok="modalFormOk"></user-area-auth-modal>
    
    <thawOrfreezeModal ref="thawOrfreezeForm" @ok="modalFormOk"></thawOrfreezeModal>

    <password-modal ref="passwordmodal" @ok="passwordModalOk"></password-modal>

    <sys-user-agent-modal ref="sysUserAgentModal"></sys-user-agent-modal>

    <!-- 用户回收站 -->
    <user-recycle-bin-modal :visible.sync="recycleBinVisible" @ok="modalFormOk"/>

  </a-card>
</template>

<script>
  import UserModal from './modules/UserModal'
  import PasswordModal from './modules/PasswordModal'
  import UserAreaAuthModal from './modules/userAreaAuthModal'
  import {putAction,getFileAccessHttpUrl,getAction,deleteAction} from '@/api/manage';
  import {frozenBatch} from '@/api/api'
  import {JeecgListMixin} from '@/mixins/JeecgListMixin'
  import SysUserAgentModal from "./modules/SysUserAgentModal";
  import JInput from '@/components/jeecg/JInput'
  import UserRecycleBinModal from './modules/UserRecycleBinModal'
  import thawOrfreezeModal from './modules/thawOrfreezeModal'
  import JSuperQuery from '@/components/jeecg/JSuperQuery'

  export default {
    name: "UserList",
    mixins: [JeecgListMixin],
    components: {
      SysUserAgentModal,
      UserModal,
      PasswordModal,
      UserAreaAuthModal,
      JInput,
      UserRecycleBinModal,
      JSuperQuery,
      thawOrfreezeModal
    },
    data() {
      return {
        description: '这是用户管理页面',
        queryParam: {},
        recycleBinVisible: false,
        url: {
          syncUser: "/process/extActProcess/doSyncUser",
          list: "/sys/user/list",
          delete: "/sys/user/delete",
          deleteBatch: "/sys/user/deleteBatch",
          exportXlsUrl: "/sys/user/exportXls",
          importExcelUrl: "sys/user/importExcel",
          deleteByUserId:"/jeecg-engineering/engineering/inspectionTeamUser/deleteByUserId",
          inspectionUserList:"/jeecg-engineering/inspection/inspectionUser/list"
        },
      }
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      // i18n：表头使用 computed 以响应语言切换
      columns() {
        return [
          {
            title: this.$t('登录账号'),
            align: "center",
            dataIndex: 'username',
            width: 120,
            sorter: true
          },
          {
            title: this.$t('账号姓名'),
            align: "center",
            width: 100,
            dataIndex: 'realname',
          },
          {
            title: this.$t('头像'),
            align: "center",
            width: 120,
            dataIndex: 'avatar',
            scopedSlots: {customRender: "avatarslot"}
          },

          {
            title: this.$t('性别'),
            align: "center",
            width: 80,
            dataIndex: 'sex_dictText',
            customRender: (t) => (t ? this.$t(t) : ''),
            sorter: true
          },
          {
            title: this.$t('生日'),
            align: "center",
            width: 100,
            dataIndex: 'birthday'
          },
          {
            title: this.$t('手机号码'),
            align: "center",
            width: 100,
            dataIndex: 'phone'
          },
          {
            title: this.$t('部门'),
            align: "center",
            width: 180,
            dataIndex: 'orgCodeTxt'
          },
          {
            title: this.$t('负责部门'),
            align: "center",
            width: 180,
            dataIndex: 'departIds_dictText',
            customRender: (t) => (t ? this.$t(t) : ''),
          },
          {
            title: this.$t('状态'),
            align: "center",
            width: 80,
            dataIndex: 'status_dictText',
            customRender: (t) => (t ? this.$t(t) : ''),
          },
          {
            title: this.$t('操作'),
            dataIndex: 'action',
            scopedSlots: {customRender: 'action'},
            align: "center",
            width: 210
          }

        ]
      },
      superQueryFieldList() {
        return [
          { type: 'input', value: 'username', text: this.$t('登录账号'), },
          { type: 'input', value: 'realname', text: this.$t('账号姓名'), },
          { type: 'select', value: 'sex', text: this.$t('性别'), dictCode: 'sex' },
        ]
      }
    },
    methods: {
      getAvatarView: function (avatar) {
        return getFileAccessHttpUrl(avatar)
      },

      batchFrozen: function (status) {
        if (this.selectedRowKeys.length <= 0) {
          this.$message.warning(this.$t('请选择一条记录！'));
          return false;
        } else {
          let ids = "";
          let that = this;
          let isAdmin = false;
          that.selectionRows.forEach(function (row) {
            if (row.username == 'admin') {
              isAdmin = true;
            }
          });
          if (isAdmin) {
            that.$message.warning(that.$t('管理员账号不允许此操作,请重新选择！'));
            return;
          }
          that.selectedRowKeys.forEach(function (val) {
            ids += val + ",";
          });
          that.$confirm({
            title: that.$t("确认操作"),
            content: that.$t("是否{action}选中账号?", { action: status == 1 ? that.$t('解冻') : that.$t('冻结') }),
            onOk: function () {
              frozenBatch({ids: ids, status: status}).then((res) => {
                if (res.success) {
                  that.$message.success(res.message);
                  that.loadData();
                  that.onClearSelected();
                } else {
                  that.$message.warning(res.message);
                }
              });
            }
          });
        }
      },
      handleMenuClick(e) {
        if (e.key == 1) {
          this.batchDel();
        } else if (e.key == 2) {
          this.batchFrozen(2);
        } else if (e.key == 3) {
          this.batchFrozen(1);
        }
      },
      handleFrozen: function (id, status, username) {
        let that = this;
        //TODO 后台校验管理员角色
        if ('admin' == username) {
          that.$message.warning(that.$t('管理员账号不允许此操作！'));
          return;
        }
        this.$refs.thawOrfreezeForm.init(id,status);
        // frozenBatch({ids: id, status: status}).then((res) => {
        //   if (res.success) {
        //     that.$message.success(res.message);
        //     that.loadData();
        //   } else {
        //     that.$message.warning(res.message);
        //   }
        // });
      },
      handleChangePassword (username){
        this.$refs.passwordmodal.show(username);
      },
      handleAgentSettings (username){
        this.$refs.sysUserAgentModal.agentSettings(username);
        this.$refs.sysUserAgentModal.title = this.$t("账号代理人设置");
      },
      passwordModalOk() {
        //TODO 密码修改完成 不需要刷新页面，可以把datasource中的数据更新一下
      },
      handleAreaAuth (record){
        // 用户区域授权
        this.$refs.userAreaModalForm.edit(record);
        this.$refs.userAreaModalForm.title = this.$t("新增");
        this.$refs.userAreaModalForm.disableSubmit = false;
      },
      handleDelete(id) { 
        getAction(this.url.inspectionUserList,{userId:id}).then(res=>{
          if(res.success){ 
            if(res.result.records.length>0){
              this.$confirm({
                title: this.$t("提示"),
                content: this.$t("该账号已被巡检关联，是否删除该账号？"),
                onOk: () => {
                  deleteAction(this.url.delete,{id:id}).then(res=>{ 
                    if(res.success){
                      this.$message.success(res.message);
                      this.loadData();
                    }else{
                      this.$message.warning(res.message);
                    }
                  })
                  deleteAction(this.url.deleteByUserId,{userId:id}).then(res=>{})
                }
              })
            }else{
              deleteAction(this.url.delete,{id:id}).then(res=>{ 
                if(res.success){
                  this.$message.success(res.message);
                  this.loadData();
                }else{
                  this.$message.warning(res.message);
                }
              })
            }
          }else{
            this.$message.warning(res.message);
          }
        })
      },
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less'
</style>